// Mirrors Listing::SpaceFit for the live previews in the flow; the server
// recomputes every range from fit_* params, so this never decides a query.

const METRE_CUTOFF = 10

// Float products like 200 * 0.3 land a hair above 60, which ceil would push to 65.
const clean = (value) => Math.round(value * 1e6) / 1e6

export function parseWidth(raw, unit) {
  const match = String(raw).trim().toLowerCase().match(/^(\d+(?:\.\d+)?)\s*(cm|m)?$/)
  if (!match) return null

  const value = parseFloat(match[1])
  const resolved = match[2] || unit || guessUnit(value)
  return { cm: Math.round(resolved === "m" ? value * 100 : value), unit: resolved }
}

export function guessUnit(value) {
  return value < METRE_CUTOFF ? "m" : "cm"
}

export function isValidWidth(config, cm) {
  const [min, max] = config.width_bounds
  return Number.isInteger(cm) && cm >= min && cm <= max
}

export function widthRange(config, anchor, widthCm, idea) {
  const span = config.anchors[anchor].span
  const bounds = {
    pair: () => span.map((ratio) => (widthCm * ratio - config.pair_gap) / 2),
    gallery: () => config.gallery_share.map((ratio) => widthCm * ratio),
  }[idea]?.() ?? span.map((ratio) => widthCm * ratio)

  const step = config.round_to
  return [Math.floor(clean(bounds[0] / step)) * step, Math.ceil(clean(bounds[1] / step)) * step]
}

export function displayWidth(cm) {
  return cm < 100 ? `${cm}cm` : `${parseFloat((cm / 100).toFixed(2))}m`
}
